export default __webpack_public_path__ + "static/media/miscellaneous16.90a696bf.png";